import { render, staticRenderFns } from "./ListaPrecoServicoSelect.vue?vue&type=template&id=2c721a5a"
import script from "./ListaPrecoServicoSelect.vue?vue&type=script&lang=js"
export * from "./ListaPrecoServicoSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports